'use strict';

export const version: string = '0.0.49';
// Prova de Certificação
export const applicationId: number = 4;
export const emailPW: string = 'oi@email.com';
export const passPW: string = 'aQmws5NJuMLH6TJrzUpWT3qguJwMdUmsksZyYzsqHwN6TMREfs';

//export const tokenPS: string = '774D9CB1F5724573A3788DDEEE088808';
//export const emailPS: string = 'cintia@institutototum.com.br';

export const tokenPS: string = '92061453-55a3-4e75-a217-0f3d53eea53ce1afd294445da29eaad20a9aa051fb1c43be-371a-43f3-9328-44c501ad1cdc';
export const emailPS: string = 'cintia@institutototum.com.br';
export const baseUrlGateway: string = 'https://paygtw.institutototum.com.br/api/';
export const baseUrlVoucher: string = 'https://vouchers.institutototum.com.br/voucher/';

export const urlIp: string = 'https://httpbin.org/ip';
export const installmentsQuantity: number = 0;

const _hostName = window.location.hostname;
const _hostUrl = window.location.href;
let _company: string = null;
let _baseUrl: string = null;
let _certificatedUrl: string = null;
let _proofId: number = null;
let _baseUrlGateway: string = null;
let _installmentsURL: string = null;
let _quizzEnabled: boolean = true;
let _quizzProofId: number = null;

switch (_hostName) {

  // Produção - RPPS
  case 'rpps.certificaonline.institutototum.com.br':
    _company = 'RPPS';
    _baseUrl = 'https://api.rpps.certificaonline.institutototum.com.br';
    _baseUrlGateway = 'https://paygtw.institutototum.com.br/api/';
    _certificatedUrl = 'https://certificated.certificaonline.institutototum.com.br';
    _installmentsURL = 'https://pagseguro.uol.com.br/checkout/v2/installments.json?';
    _proofId = 3;
    _quizzProofId = 73;
    break;

  // Homologação - RPPS
  case 'stg.rpps.certificaonline.institutototum.com.br':
    _company = 'RPPS';
    _baseUrl = 'https://stg.api.rpps.certificaonline.institutototum.com.br';
    _baseUrlGateway = 'https://paygtw.institutototum.com.br/api/';
    _certificatedUrl = 'https://stg.certificated.certificaonline.institutototum.com.br';
    _installmentsURL = 'https://pagseguro.uol.com.br/checkout/v2/installments.json?';
    _proofId = 3;
    _quizzProofId = 73;
    break;

  // Desenvolvimento - RPPS
  case 'dev.rpps.certificaonline.institutototum.com.br':
    _company = 'RPPS';
    _baseUrl = 'https://dev.api.rpps.certificaonline.institutototum.com.br';
    _baseUrlGateway = 'https://paygtw.institutototum.com.br/api/';
    _certificatedUrl = 'https://dev.certificated.certificaonline.institutototum.com.br';
    _installmentsURL = 'https://pagseguro.uol.com.br/checkout/v2/installments.json?';
    _proofId = 3;
    _quizzProofId = 73;
    break;

  // Desenvolvimento Local
  case 'localhost':
    _company = 'RPPS';
    _baseUrl = '/api';
    _baseUrlGateway = 'https://paygtw.institutototum.com.br/api/';
    _certificatedUrl = 'https://stg.certificated.certificaonline.institutototum.com.br';
    _installmentsURL = 'https://pagseguro.uol.com.br/checkout/v2/installments.json?';
    _proofId = 3;
    _quizzProofId = 73;
    break;
}

export const proofId = _proofId;
export const company = _company;
export const baseUrl = _baseUrl;
export const hostUrl = _hostUrl;
export const certificatedUrl = 'https://adminapi.rpps.certificaonline.institutototum.com.br';
//_certificatedUrl;
//export const baseUrlGateway = _baseUrlGateway;
export const installmentsURL = _installmentsURL;
export const quizzEnabled = _quizzEnabled;
export const quizzProofId = _quizzProofId;

console.log('company--->' + company);
console.log('baseUrl--->' + baseUrl);
console.log('hostUrl--->' + hostUrl);
console.log('baseUrlGateway--->' + baseUrlGateway);
console.log('installmentsURL--->' + installmentsURL);
console.log('quizzEnabled--->' + quizzEnabled);
console.log('quizzProofId--->' + quizzProofId);



// WEBPACK FOOTER //
// ./src/app/app.config.ts